import React, { useState, useEffect } from "react";
import { Button, Card, Container, Spinner, Alert } from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../constants";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Printer, ArrowLeft } from "lucide-react";
import Brandstrek from "../../../assets/images/brandstrek-logo.png";
import Signature from "../../../assets/images/02.png";

const InvoiceDetail = () => {
  const { client_id } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  const breadcrumbItems = [
    { title: "Accounts", link: "/" },
    { title: "Invoices", link: "/admin/accounts/invoice" },
    { title: "Invoice Detail", link: "#!" },
  ];

  useEffect(() => {
    const fetchInvoiceDetail = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/invoice/get-user-invoice/${client_id}`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (
          response.data &&
          response.data.status === "success" &&
          response.data.data
        ) {
          setInvoice(response.data.data);
        } else {
          // setError("No invoice data found or invalid response format.");
        }
      } catch (error) {
        console.error("Error fetching invoice details:", error);
        // setError("Failed to load invoice. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchInvoiceDetail();
  }, [client_id]);

  const handlePrint = () => {
    window.print();
  };

  const printStyles = `
        @media screen {
            .invoice-container {
                padding: 15px 15px !important; /* Reduced side margins for desktop view */
                max-width: 900px;
                margin: 0 auto;
            }
            
            .signature-section {
                text-align: right;
                margin-top: 20px;
            }
            
            .signature-img {
                width: 150px;
                height: auto;
                display: block;
                margin-left: auto;
            }
            
            .signature-line {
                width: 180px;
                border-top: 1px solid #000;
                margin: 5px 0 3px auto;
            }
            
            .signature-text {
                margin-top: 3px;
                text-align: right;
            }
            .signature-container {
                margin-top: 130px !important;
                text-align: right !important;
            }
            
            hr {
                margin: 15px -15px !important;
            }
        }

        @media print {
            @page {
                size: A4;
                margin: 10mm 12.5mm 10mm 12.5mm;
            }
            
            body {
                width: 210mm;
                height: 297mm;
                margin: 0 !important;
                padding: 0 !important;
                color: #000;
                background: #fff;
                font-size: 12pt;
                line-height: 1.4;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
            }
            
            .page-content {
                width: 100% !important;
                margin: 0 !important;
                padding: 0 !important;
            }
            
            .no-print {
                display: none !important;
            }
            
            .invoice-detail-card {
                width: 100%;
                border: none !important;
                box-shadow: none !important;
                margin: 0 !important;
                padding: 0 !important;
                page-break-after: avoid;
            }
            
            .card-body {
                padding: 0 !important;
            }
            
            .invoice-container {
                padding: 0 !important;
                max-width: 185mm !important;
                margin: 0 auto !important;
                padding-top: 5mm !important;
            }
            
            .invoice-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 15px !important;
                margin-top: 5mm !important; 
            }
            
            .invoice-title {
                background-color: #00c853 !important;
                color: #000 !important;
                padding: 5px 15px !important;
                font-size: 24pt !important;
                font-weight: bold !important;
                margin-bottom: 15px !important;
                text-transform: uppercase !important;
                width: 50% !important;
            }
            
            .company-info {
                text-align: right !important;
            }
            
            .invoice-data {
                display: flex;
                justify-content: space-between;
                margin-bottom: 15px !important;
            }
            
            table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 15px !important;
            }
            
            table th, table td {
                border-bottom: 1px solid #ddd !important;
                padding: 5px 3px !important;
                text-align: left !important;
            }
            
            table th {
                font-weight: bold !important;
            }
            
            .invoice-summary {
                display: flex;
                justify-content: space-between;
            }
            
            .invoice-info {
                width: 45% !important;
            }
            
            .invoice-totals {
                width: 45% !important;
                text-align: right !important;
            }
            
            .total-row {
                font-weight: bold !important;
                font-size: 16pt !important;
                margin-top: 5px !important;
            }
            
            /* Fix for the signature section in print mode */
            .signature-container {
                margin-top: 150px !important;
                text-align: right !important;
            }
            
            .signature-img {
                width: 150px !important;
                display: block !important;
                margin-left: auto !important;
            }
            
            .signature-line {
                width: 200px !important;
                border-top: 1px solid #000 !important;
                margin: 5px 0 3px auto !important;
            }
            
            .signature-text {
                text-align: right !important;
                margin-top: 3px !important;
            }
            
            .invoice-footer {
                text-align: center !important;
                margin-top: 25px !important;
                position: fixed !important;
                bottom: 10mm !important;
                width: 100% !important;
            }
            
            hr {
                border-top: 1px solid #ddd !important;
                margin: 8px 0 !important;
            }
            
            .price-column {
                text-align: right !important;
            }
            
            .quantity-column {
                text-align: center !important;
            }
        }

        /* Mobile styles */
        @media (max-width: 767.98px) {
            .signature-container {
                margin-top: 30px !important;
            }
            
            .signature-img {
                margin: 0 auto !important;
            }
            
            .signature-line {
                margin: 5px auto 3px auto !important;
            }
            
            .signature-text {
                text-align: center !important;
            }

            .signature-container {
                margin-top: 300px !important;
                text-align: right !important;
            }
        }
    `;

  if (loading) {
    return (
      <div
        className="page-content d-flex justify-content-center"
        style={{ minHeight: "80vh" }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  const calculateSubtotal = () => {
    if (!invoice?.invoice_items) return 0;

    return invoice.invoice_items.reduce((sum, item) => {
      const amount = parseFloat(item.amount) || 0;
      return sum + amount;
    }, 0);
  };

  const calculateTaxAmount = () => {
    // Otherwise calculate from tax rate
    const subtotal = calculateSubtotal();

    // Try different ways to get the tax rate
    const taxRate =
      invoice?.tax?.gst || invoice?.gst_rate || invoice.tax_id?.gst || 0;

    console.log("gst: ", invoice.tax_id?.gst);
    console.log("taxRate: ", taxRate);

    return (subtotal * parseFloat(taxRate)) / 100;
  };

  const calculateDiscountAmount = () => {
    // First check for fixed amount discount
    if (
      invoice?.discount_amount !== undefined &&
      invoice?.discount_amount !== null
    ) {
      return parseFloat(invoice.discount_amount) || 0;
    }

    // Then check for percentage discount
    if (
      invoice?.discount_percentage !== undefined &&
      invoice?.discount_percentage !== null
    ) {
      const subtotal = calculateSubtotal();
      return (subtotal * parseFloat(invoice.discount_percentage)) / 100;
    }

    return 0;
  };

  const calculateTotalAmount = () => {
    // const subtotal = calculateSubtotal();
    // const taxAmount = calculateTaxAmount();
    // const discountAmount = calculateDiscountAmount();
    console.log(
      "subtotal: ",
      subtotal,
      "taxAmount: ",
      taxAmount,
      "discountAmount: ",
      discountAmount
    );

    return subtotal + taxAmount - discountAmount;
  };

  if (!invoice) {
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Invoice Detail"
            breadcrumbItems={breadcrumbItems}
          />
          <Alert color="danger">{"Invoice not found"}</Alert>
          <Button
            color="secondary"
            onClick={() => navigate("/admin/accounts/invoice")}
          >
            <ArrowLeft size={16} className="me-1" /> Back to Invoice List
          </Button>
        </Container>
      </div>
    );
  }

  const subtotal = calculateSubtotal();
  const taxAmount = calculateTaxAmount();
  const discountAmount = calculateDiscountAmount();
  const totalAmount = calculateTotalAmount();

  return (
    <div className="page-content">
      <style>{printStyles}</style>
      <Container fluid className="print-container">
        <Breadcrumbs
          title="Invoice Detail"
          breadcrumbItems={breadcrumbItems}
          className="no-print"
        />

        <div className="mb-4 d-flex justify-content-end no-print">
          <Button
            color="primary"
            onClick={handlePrint}
            className="print-button"
          >
            <Printer size={16} className="me-1" /> Print Invoice
          </Button>
        </div>

        <Card className="invoice-detail-card">
          <div className="card-body">
            <div
              className="invoice-container mx-auto"
              style={{ maxWidth: "900px", padding: "15px" }}
            >
              {/* Invoice Header */}
              <div className="invoice-header d-flex justify-content-between align-items-center mb-3">
                <div className="logo" style={{ maxWidth: "180px" }}>
                  <img
                    src={Brandstrek}
                    alt="Brands Trek"
                    className="img-fluid"
                  />
                </div>
                <div className="company-info text-end">
                  <h3 className="mb-1">Brands Trek LLP</h3>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: "0.85rem", lineHeight: "1.3" }}
                  >
                    7th floor, Tower 1, Hilite Business Park,
                    <br />
                    National Highway 66 Bypass,
                    <br />
                    Thondayad, Kozhikode, 673014
                    <br />
                    <span className="d-inline-block mt-1">+91 7594909991</span>
                  </p>
                </div>
              </div>

              <div
                className="invoice-title bg-success text-white py-2 px-3 mb-3"
                style={{ width: "40%" }}
              >
                <h3 className="text-white mb-0">INVOICE</h3>
              </div>

              {/* Invoice Data */}
              <div className="invoice-data d-flex justify-content-between mb-3">
                <div>
                  <div className="mb-1">
                    <strong>Invoice to: </strong>
                    <span className="ms-1">
                      {invoice.client_id ? invoice.client_id : "Sphecho"}
                    </span>
                  </div>
                </div>
                <div className="text-end">
                  <div className="mb-1">
                    <strong>Invoice# </strong>
                    <span className="ms-1">{invoice.invoice_number}</span>
                  </div>
                  <div>
                    <strong>Date </strong>
                    <span className="ms-1">{invoice.invoice_date}</span>
                  </div>
                </div>
              </div>

              {/* Invoice Items */}
              <div className="table-responsive mb-3">
                <table className="table">
                  <thead>
                    <tr>
                      <th style={{ width: "40%" }}>Item</th>
                      <th className="quantity-column" style={{ width: "20%" }}>
                        Quantity
                      </th>
                      <th className="price-column" style={{ width: "20%" }}>
                        Price
                      </th>
                      <th className="price-column" style={{ width: "20%" }}>
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.invoice_items &&
                      invoice.invoice_items.map((item, index) => (
                        <tr key={index}>
                          <td>{item.description}</td>
                          <td className="quantity-column">{item.quantity}</td>
                          <td className="price-column">
                            ₹{parseFloat(item.unit_price).toFixed(2)}
                          </td>
                          <td className="price-column">
                            ₹{parseFloat(item.amount).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {/* Notes and Payment Details */}
              <div className="invoice-summary d-flex justify-content-between">
                <div className="invoice-info" style={{ width: "48%" }}>
                  {/* <div className="mb-3">
                                        <h5 className="mb-1">TO BE TAKEN CARED OF</h5>
                                        <p className="mb-1">Shoots shall be Completed in 4-8days</p>
                                        <ul className="ps-3 mb-1" style={{ fontSize: "0.9rem" }}>
                                            <li>video production charge per 2500</li>
                                            <li>video content - 1000</li>
                                            <li>carousal - 1500</li>
                                            <li>poster content - 500</li>
                                            <li>carousal - per page 300</li>
                                        </ul>
                                        <p className="small mb-0">The actual price is based on the quantity, and if the quantity decreases, the amount will be revised.</p>
                                    </div> */}

                  <div>
                    <h5 className="mb-1">PAYMENT METHOD</h5>
                    <p className="mb-1" style={{ fontSize: "0.9rem" }}>
                      Account name: CREATIVE BRANDS TREK LLP
                    </p>
                    <p className="mb-1" style={{ fontSize: "0.9rem" }}>
                      Account no: 10221666918
                    </p>
                    <p className="mb-1" style={{ fontSize: "0.9rem" }}>
                      IFSC: IDFB0080931
                    </p>
                    <p className="mb-1" style={{ fontSize: "0.9rem" }}>
                      Bank name: IDFC FIRST
                    </p>
                    <p className="mb-0" style={{ fontSize: "0.9rem" }}>
                      Branch: CALICUT BRANCH
                    </p>
                  </div>
                </div>

                <div className="invoice-totals" style={{ width: "48%" }}>
                  <div className="d-flex justify-content-between mb-1">
                    <strong>Subtotal</strong>
                    <span>₹{subtotal.toFixed(2)}</span>
                  </div>
                  {invoice.tax_id && (
                    <div className="d-flex justify-content-between mb-1">
                      <strong>Tax ({invoice.tax?.gst || 0}%)</strong>
                      <span>₹{taxAmount.toFixed(2)}</span>
                    </div>
                  )}
                  {parseFloat(invoice.discount_amount || 0) > 0 && (
                    <div className="d-flex justify-content-between mb-1">
                      <strong>
                        Discount{" "}
                        {invoice.discount_type === "percentage"
                          ? `(${invoice.discount_percentage}%)`
                          : ""}
                      </strong>
                      <span>
                        -₹{parseFloat(invoice.discount_amount || 0).toFixed(2)}
                      </span>
                    </div>
                  )}
                  {/* {(invoice.discount_amount || invoice.discount_percentage) && (
                                        <div className="d-flex justify-content-between mb-1">
                                            <strong>
                                                Discount {invoice.discount_percentage ? `(${invoice.discount_percentage}%)` : ''}
                                            </strong>
                                            <span>-₹{discountAmount.toFixed(2)}</span>
                                        </div>
                                    )} */}
                  <hr />
                  <div className="total-row d-flex justify-content-between">
                    <strong>Total</strong>
                    <strong>₹{totalAmount.toFixed(2)}/-</strong>
                  </div>

                  {/* Improved Signature Section */}
                  <div className="signature-container mt-4">
                    <img
                      src={Signature}
                      alt="Signature"
                      className="signature-img"
                    />
                    <div className="signature-line"></div>
                    <p className="signature-text">Authorized Signed</p>
                  </div>
                </div>
              </div>

              <div className="text-center mt-4 invoice-footer">
                <p>Thank you for your visit!</p>
              </div>
            </div>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default InvoiceDetail;
